import * as React from 'react';
import { css } from 'emotion';

const Gotham = `'Gotham A', 'Gotham B', sans-serif;`;

interface FlatButtonProps {
  onClick?: () => void;
  height: string;
  width: string;
  bgColor: string;
  color: string;
  borderColor: string;
  style?: any;
  label: string;
}

class Benefits extends React.PureComponent<FlatButtonProps, {}> {
  onClick = (e: any) => {
    e.preventDefault();
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    const { height, width, bgColor, color, borderColor, label } = this.props;
    const buttonStyle = css`
      padding: 0 24px;
      height: ${height};
      color: ${color};
      width: ${width};
      background-color: ${bgColor};
      border: 1px solid ${borderColor};
      text-align: center;
      font-family: ${Gotham};
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 1px;
      line-height: 20px;
      text-transform: uppercase;
      outline: none;
      &:hover {
        cursor: pointer;
      }
    `;
    return (
      <button
        onClick={this.onClick}
        className={buttonStyle}
        data-cypress={label}
      >
        {label}
      </button>
    );
  }
}

export default Benefits;
